import paths from './icon-paths.js';
import { raw, esc } from './html.js';

// Inline SVG icon. Decorative by default; pass `label` when the icon is the
// only content of a control that has no other accessible name.
export function icon(name, { size = 20, label = '', className = '', stroke = 1.75 } = {}) {
  const p = paths[name];
  if (!p) throw new Error(`unknown icon ${name}`);
  const a11y = label ? `role="img" aria-label="${esc(label)}"` : 'aria-hidden="true" focusable="false"';
  return raw(
    `<svg class="icon${className ? ` ${esc(className)}` : ''}" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="${stroke}" stroke-linecap="round" stroke-linejoin="round" ${a11y}>${p}</svg>`,
  );
}
